import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sms: {
    language: "FA",
    counter: "",
    unitLength: "",
  },
  currentStep: 1,
  message: "",
  numbers: [],
  checked: false,
  file: null,
  fileName: "",
  type: 0,
};

export const smsSlice = createSlice({
  name: "sms",
  initialState,
  reducers: {
    setStep: (state, action) => {
      state.currentStep = action.payload;
    },
    setMessage: (state, action) => {
      state.message = action.payload;
    },
    setNumbers: (state, action) => {
      state.numbers = action.payload;
    },
    setChecked: (state, action) => {
      state.checked = action.payload;
    },
    setSms: (state, action) => {
      state.sms = { ...state.sms, ...action.payload };
    },
    setFile: (state, action) => {
      state.file = action.payload;
    },
    setFileName: (state, action) => {
      state.fileName = action.payload;
    },
    setType: (state, action) => {
      state.type = action.payload;
    },
  },
});

export const {
  setStep,
  setMessage,
  setNumbers,
  setChecked,
  setSms,
  setFile,
  setFileName,
  setType,
} = smsSlice.actions;
export default smsSlice.reducer;
